import { checkPermissionByRoles } from "../utils/checkPermission";
import { FaRegFileLines } from "react-icons/fa6";
import { FiTrendingUp } from "react-icons/fi";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";
import NotificationsDrawer from "./NotificationsDrawer";
import NotificationBadge from "./NotificationBadge";
import { useCareManagerChatBadge } from "../hooks/useCareManagerChatBadge";
import { isOnboardingNavigationLocked } from "../utils/providerOnboarding";
import "./NotificationBadge.css";
import classes from "./Sidebar.module.css";

const Sidebar = () => {
  const user = useSelector((state) => state?.user);

  const [openProviders, setOpenProviders] = useState(false);
  const [openUsers, setOpenUsers] = useState(false);
  const [notificationsDrawerOpen, setNotificationsDrawerOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);

  const businessId = user.user?.businessId;
  const businessIdentifier = user.user?.businessIdentifier;
  const isCareManager =
    user?.user?.role === "careManager" ||
    user?.user?.providerType === "Care Manager";
  const isTherapistProvider =
    user?.user?.role === "provider" &&
    user?.user?.providerType !== "Care Manager" &&
    user?.user?.providerType !== "Psychiatric Consultant";
  const unreadChatCount = useCareManagerChatBadge(isCareManager);
  const onboardingLocked = isOnboardingNavigationLocked(user?.user);

  const dashboardIcon = (isActive) => (
    <div className="me-2">
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z"
          fill={isActive ? "#064260" : "#8E8E93"}
        />
      </svg>
    </div>
  );

  const linkClass = ({ isActive }) =>
    isActive
      ? `d-flex align-items-center nav-link active ${classes.activeLink}`
      : "d-flex align-items-center nav-link";

  return (
    <div className={classes.bodyScrollbar}>
      <div className={classes.panel}>
        <ul className="nav flex-column mb-auto">
          {/* Dashboard */}
          {(user?.user?.role === "admin" ||
            user?.user?.role === "business") && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/dashboard">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        fill="none"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Dashboard
                  </>
                )}
              </NavLink>
            </li>
          )}
          {/* Calendar */}

          {(user?.user?.role == "careManager" ||
            user?.user?.role == "psychiatricConsultant" ||
            user?.user?.providerType == "Care Manager" ||
            user?.user?.providerType == "Psychiatric Consultant") && (
            <li className="nav-item">
              <NavLink to="/dashboard" className={linkClass}>
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        fill="none"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Dashboard
                  </>
                )}
              </NavLink>
            </li>
          )}

          {(user?.user?.role == "careManager" ||
            user?.user?.providerType == "Care Manager") && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/careManager/my-patients">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        fill="none"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    My Patient
                  </>
                )}
              </NavLink>
            </li>
          )}

          {(user?.user?.role == "psychiatricConsultant" ||
            user?.user?.providerType == "Psychiatric Consultant") && (
            <li className="nav-item">
              <NavLink
                className={linkClass}
                to="/psychiatricConsultant/my-patients"
              >
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        fill="none"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    My Patients
                  </>
                )}
              </NavLink>
            </li>
          )}

          {(user?.user?.role == "careManager" ||
            user?.user?.providerType == "Care Manager") && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/activity-cocm">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <FiTrendingUp
                        size={20}
                        color={isActive ? "#064260" : "#8E8E93"}
                      />
                    </div>
                    Activity
                  </>
                )}
              </NavLink>
            </li>
          )}

          {(user?.user?.role == "careManager" ||
            user?.user?.providerType == "Care Manager") && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/messages">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        fill="none"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                        <path
                          d="M7 9H17V11H7V9ZM7 12H14V14H7V12Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Messages
                    {unreadChatCount > 0 && (
                      <div className="notifications-count-badge">
                        {unreadChatCount}
                      </div>
                    )}
                  </>
                )}
              </NavLink>
            </li>
          )}

          {(user?.user?.role == "careManager" ||
            user?.user?.providerType == "Care Manager") && (
            <li className="nav-item">
              <NavLink to="/appointments" className={linkClass}>
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        fill="none"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19ZM7 10H12V15H7V10Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Schedule
                  </>
                )}
              </NavLink>
            </li>
          )}

          {(user?.user?.role == "careManager" ||
            user?.user?.providerType == "Care Manager") && (
            <li className="nav-item">
              <NavLink to="/my-availability" className={linkClass}>
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        fill="none"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19ZM7 10H12V15H7V10Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Availability
                  </>
                )}
              </NavLink>
            </li>
          )}

          {isTherapistProvider && (
            <li className="nav-item">
              <NavLink to="/dashboard" className={linkClass}>
                {({ isActive }) => (
                  <>
                    {dashboardIcon(isActive)}
                    Dashboard
                  </>
                )}
              </NavLink>
            </li>
          )}

          {user?.user?.role == "provider" && !onboardingLocked && (
            <li className="nav-item">
              <NavLink to="/appointments" className={linkClass}>
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        fill="none"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19ZM7 10H12V15H7V10Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Schedule
                  </>
                )}
              </NavLink>
            </li>
          )}
          {/* Session History */}
          {user?.user?.role == "provider" && !onboardingLocked && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/session-history">
                {({ isActive }) => (
                  <>
                    <div>
                      <svg
                        className="me-2"
                        fill="none"
                        height="20"
                        viewBox="0 0 18 20"
                        width="18"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16 2H11.82C11.4 0.84 10.3 0 9 0C7.7 0 6.6 0.84 6.18 2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM9 2C9.55 2 10 2.45 10 3C10 3.55 9.55 4 9 4C8.45 4 8 3.55 8 3C8 2.45 8.45 2 9 2ZM11 16H4V14H11V16ZM14 12H4V10H14V12ZM14 8H4V6H14V8Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Session History
                  </>
                )}
              </NavLink>
            </li>
          )}
          {/* Profile */}
          {(user?.user?.role == "provider" ||
            user?.user?.role == "careManager" ||
            user?.user?.role == "psychiatricConsultant" ||
            user?.user?.providerType == "Care Manager" ||
            user?.user?.providerType == "Psychiatric Consultant") &&
            !(user?.user?.role == "provider" && onboardingLocked) && (
            <li className="nav-item">
              <NavLink to="/profile" className={linkClass}>
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_10604_2332)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M2.25 5.4165C2.25 3.62158 3.70508 2.1665 5.5 2.1665H18.5C20.295 2.1665 21.75 3.62158 21.75 5.4165V18.4165C21.75 20.2115 20.295 21.6665 18.5 21.6665H14.0242L12.9014 23.3508C12.7005 23.6521 12.3623 23.8332 12 23.8332C11.6377 23.8332 11.2995 23.6521 11.0986 23.3508L9.97579 21.6665H5.5C3.70508 21.6665 2.25 20.2115 2.25 18.4165V5.4165ZM9.14794 9.35589C9.14794 7.78086 10.4226 6.49984 12 6.49984C13.5774 6.49984 14.852 7.78086 14.852 9.35589C14.852 10.9309 13.5774 12.2119 12 12.2119C10.4226 12.2119 9.14794 10.9309 9.14794 9.35589ZM6.60489 17.1181C7.11453 14.6018 9.33358 12.7044 12 12.7044C14.6664 12.7044 16.8855 14.6018 17.3951 17.1181C17.4597 17.4366 17.3777 17.7674 17.1719 18.0189C16.9662 18.2706 16.6583 18.4165 16.3333 18.4165H7.66667C7.34165 18.4165 7.03379 18.2706 6.82805 18.0189C6.62229 17.7674 6.54038 17.4366 6.60489 17.1181Z"
                            fill={isActive ? "#064260" : "#8E8E93"}
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_10604_2332">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    Profile
                  </>
                )}
              </NavLink>
            </li>
          )}
          {/* Availability */}
          {user?.user?.role == "provider" && !onboardingLocked && (
            <li className="nav-item">
              <NavLink to="/my-availability" className={linkClass}>
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        fill="none"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19ZM7 10H12V15H7V10Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    My Availability
                  </>
                )}
              </NavLink>
            </li>
          )}
          {/* Clients */}
          {user?.user?.role == "provider" && !onboardingLocked && (
            <li className="nav-item">
              <NavLink to="/clients" className={linkClass}>
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        fill="none"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Clients
                  </>
                )}
              </NavLink>
            </li>
          )}
          {/* Users */}
          {(user?.user?.role === "admin" ||
            user?.user?.role === "business") && (
            <li className="nav-item">
              <NavLink
                className={linkClass}
                onClick={() => setOpenUsers(!openUsers)}
                to="/users"
              >
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        fill="none"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Users
                  </>
                )}
              </NavLink>
            </li>
          )}
          {user?.user?.role === "admin" && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/registry-cocm">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        fill="none"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    CoCM Registry
                  </>
                )}
              </NavLink>
            </li>
          )}

          {user?.user?.role === "admin" && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/activity-cocm">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <FiTrendingUp
                        size={20}
                        color={isActive ? "#064260" : "#8E8E93"}
                      />
                    </div>
                    CoCM Activity
                  </>
                )}
              </NavLink>
            </li>
          )}
          {/* Upcoming Sessions */}
          {(user?.user?.role === "admin" ||
            user?.user?.role === "business") && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/upcoming-sessions">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        fill="none"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19ZM7 10H12V15H7V10Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Upcoming Sessions
                  </>
                )}
              </NavLink>
            </li>
          )}
          {/* Session History */}
          {user?.user?.role === "admin" && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/admin/session-history">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_14090_6850)">
                          <g clipPath="url(#clip1_14090_6850)">
                            <path
                              d="M4.19794 11.1494H24.1493"
                              stroke={isActive ? "#064260" : "#8E8E93"}
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.10144 5.28125H3.95029C3.36089 5.31487 2.80888 5.58084 2.4153 6.02085C2.02171 6.46086 1.81867 7.03899 1.8507 7.62847V21.7118C1.81867 22.3013 2.02171 22.8794 2.4153 23.3194C2.80888 23.7594 3.36089 24.0254 3.95029 24.059H22.0497C22.6391 24.0254 23.1911 23.7594 23.5847 23.3194C23.9783 22.8794 24.1813 22.3013 24.1493 21.7118V7.62847C24.1813 7.03899 23.9783 6.46086 23.5847 6.02085C23.1911 5.58084 22.6391 5.31487 22.0497 5.28125H20.6285"
                              stroke={isActive ? "#064260" : "#8E8E93"}
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M18.2812 2.93408V7.62853"
                              stroke={isActive ? "#064260" : "#8E8E93"}
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.71875 2.93408V7.62853"
                              stroke={isActive ? "#064260" : "#8E8E93"}
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M10.066 5.28108L18.2343 5.26465"
                              stroke={isActive ? "#064260" : "#8E8E93"}
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M9.47919 17.2134L12.04 20.3423L16.5209 14.8662"
                              stroke={isActive ? "#064260" : "#8E8E93"}
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </g>
                        </g>
                        <defs>
                          <clipPath id="clip0_14090_6850">
                            <rect width="26" height="26" fill="white" />
                          </clipPath>
                          <clipPath id="clip1_14090_6850">
                            <rect
                              width="28.1667"
                              height="28.1667"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    Session History
                  </>
                )}
              </NavLink>
            </li>
          )}
          {user?.user?.role === "admin" && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/admin/session-billings">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M16.0643 7.5H15.1287C14.6112 7.5 14.1912 7.92 14.1912 8.4375C14.1912 8.955 14.6112 9.375 15.1287 9.375H16.0681L16.07 10.3144C16.0709 10.8319 16.4918 11.2509 17.0093 11.25C17.5268 11.2491 17.9459 10.8281 17.945 10.3106L17.9431 9.375H18.8787C19.3962 9.375 19.8162 8.955 19.8162 8.4375C19.8162 7.92 19.3962 7.5 18.8787 7.5H17.9393L17.9375 6.56063C17.9365 6.04313 17.5156 5.62406 16.9981 5.625C16.4806 5.62594 16.0615 6.04688 16.0625 6.56438L16.0643 7.5Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M26.375 8.4375V4.6875C26.375 3.94125 26.0788 3.22594 25.5509 2.69906C25.0241 2.17125 24.3088 1.875 23.5625 1.875C20.3159 1.875 13.6841 1.875 10.4375 1.875C9.69125 1.875 8.97594 2.17125 8.44906 2.69906C7.92125 3.22594 7.625 3.94125 7.625 4.6875V25.3125C7.625 26.0587 7.92125 26.7741 8.44906 27.3009C8.97594 27.8287 9.69125 28.125 10.4375 28.125C12.875 28.125 20.1088 28.125 23.5616 28.125C24.0791 28.125 24.4991 27.705 24.4991 27.1875C24.4991 26.67 24.0791 26.25 23.5616 26.25C20.1088 26.25 12.875 26.25 10.4375 26.25C10.1891 26.25 9.95 26.1516 9.77469 25.9753C9.59844 25.8 9.5 25.5609 9.5 25.3125V4.6875C9.5 4.43906 9.59844 4.2 9.77469 4.02469C9.95 3.84844 10.1891 3.75 10.4375 3.75H23.5625C23.8109 3.75 24.05 3.84844 24.2253 4.02469C24.4016 4.2 24.5 4.43906 24.5 4.6875V8.4375C24.5 8.955 24.92 9.375 25.4375 9.375C25.955 9.375 26.375 8.955 26.375 8.4375Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M24.4831 13.3181C23.3966 13.7063 22.6175 14.7459 22.6175 15.9666C22.6175 17.5219 23.8672 18.7669 25.4225 18.7669C25.9409 18.7669 26.3675 19.1869 26.3675 19.7053C26.3675 20.2228 25.9475 20.6428 25.43 20.6428C24.9125 20.6428 24.4925 20.2228 24.4925 19.7053C24.4925 19.1878 24.0725 18.7678 23.555 18.7678C23.0375 18.7678 22.6175 19.1878 22.6175 19.7053C22.6175 20.9259 23.3975 21.9666 24.4859 22.3547L24.4812 23.445C24.4794 23.9625 24.8975 24.3844 25.415 24.3863C25.9325 24.3891 26.3544 23.97 26.3562 23.4525L26.3609 22.3594C27.4559 21.975 28.2425 20.9316 28.2425 19.7053C28.2425 18.1538 26.9731 16.8919 25.4225 16.8919C24.9078 16.8919 24.4925 16.4813 24.4925 15.9666C24.4925 15.4491 24.9125 15.0291 25.43 15.0291C25.9456 15.0291 26.3647 15.4463 26.3675 15.9609V15.9731C26.3712 16.4869 26.7894 16.9041 27.305 16.9041C27.8225 16.9041 28.2425 16.4841 28.2425 15.9666C28.2425 14.7394 27.455 13.695 26.3581 13.3116L26.3675 12.2063C26.3712 11.6888 25.955 11.2659 25.4375 11.2613C24.92 11.2575 24.4962 11.6747 24.4925 12.1913L24.4831 13.3181Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M12.3125 15.9551H19.8125C20.33 15.9551 20.75 15.5351 20.75 15.0176C20.75 14.5001 20.33 14.0801 19.8125 14.0801H12.3125C11.795 14.0801 11.375 14.5001 11.375 15.0176C11.375 15.5351 11.795 15.9551 12.3125 15.9551Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M12.3125 19.7168H19.8125C20.33 19.7168 20.75 19.2968 20.75 18.7793C20.75 18.2618 20.33 17.8418 19.8125 17.8418H12.3125C11.795 17.8418 11.375 18.2618 11.375 18.7793C11.375 19.2968 11.795 19.7168 12.3125 19.7168Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M12.3125 23.4487H19.8125C20.33 23.4487 20.75 23.0287 20.75 22.5112C20.75 21.9937 20.33 21.5737 19.8125 21.5737H12.3125C11.795 21.5737 11.375 21.9937 11.375 22.5112C11.375 23.0287 11.795 23.4487 12.3125 23.4487Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Billing
                  </>
                )}
              </NavLink>
            </li>
          )}
          {user?.user?.role == "admin" && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/support-request">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3ZM14 17H7V15H14V17ZM17 13H7V11H17V13ZM17 9H7V7H17V9Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Support Requests
                  </>
                )}
              </NavLink>
            </li>
          )}
          {user?.user?.role == "admin" && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/prompts">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.7285 6.70551H19.903V8.17906H20.7335C21.1538 8.17906 21.499 8.51797 21.499 8.93056V18.0616C21.499 18.5282 21.2238 18.8131 21.0787 18.8131H17.6515V21.5146L15.34 19.2454L14.8997 18.8131H7.8251L6.42419 20.1884C6.62932 20.2474 6.83946 20.2867 7.0596 20.2867H14.2793L17.5514 23.499C17.8967 23.8379 18.2169 24 18.477 24C18.8873 24 19.1575 23.5972 19.1575 22.8457V20.2867H21.0787C22.1394 20.2867 23 19.2896 23 18.0616V8.93056C23 7.70261 21.9843 6.70551 20.7285 6.70551ZM15.9354 15.5812C17.1862 15.5812 18.2019 14.5841 18.2019 13.3561V4.22505C18.2019 2.99219 17.1862 2 15.9354 2H2.26648C1.01566 2 0 2.9971 0 4.22505V13.3561C0 14.589 0.860561 15.5812 1.92125 15.5812H3.84251V18.1402C3.84251 19.3682 4.55797 19.6629 5.44855 18.7935L8.72069 15.5812H15.9354ZM12.5482 8.10538C13.1386 8.10538 13.6139 8.572 13.6139 9.1516C13.6139 9.72628 13.1386 10.1978 12.5482 10.1978C11.9628 10.1978 11.4825 9.73119 11.4825 9.1516C11.4825 8.57691 11.9578 8.10538 12.5482 8.10538ZM5.65369 10.1978C5.0633 10.1978 4.58799 9.73119 4.58799 9.1516C4.58799 8.572 5.06831 8.10538 5.65369 8.10538C6.23907 8.10538 6.71938 8.572 6.71938 9.1516C6.71938 9.73119 6.23907 10.1978 5.65369 10.1978ZM8.03524 9.15651C8.03524 8.57691 8.51555 8.11029 9.10093 8.11029C9.69132 8.11029 10.1666 8.57691 10.1666 9.15651C10.1666 9.73119 9.68632 10.2027 9.10093 10.2027C8.51055 10.1978 8.03524 9.73119 8.03524 9.15651Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Support Prompts
                  </>
                )}
              </NavLink>
            </li>
          )}
          {user?.user?.role == "admin" && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/solution-coach">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M3.25 5.41663C3.25 3.62171 4.70508 2.16663 6.5 2.16663H19.5C21.295 2.16663 22.75 3.62171 22.75 5.41663V18.4166C22.75 20.2116 21.295 21.6666 19.5 21.6666H15.0242L13.9014 23.3509C13.7005 23.6523 13.3623 23.8333 13 23.8333C12.6377 23.8333 12.2995 23.6523 12.0986 23.3509L10.9758 21.6666H6.5C4.70508 21.6666 3.25 20.2116 3.25 18.4166V5.41663ZM10.1479 9.35602C10.1479 7.78098 11.4226 6.49996 13 6.49996C14.5774 6.49996 15.852 7.78098 15.852 9.35602C15.852 10.931 14.5774 12.2121 13 12.2121C11.4226 12.2121 10.1479 10.931 10.1479 9.35602ZM7.60489 17.1182C8.11453 14.6019 10.3336 12.7045 13 12.7045C15.6664 12.7045 17.8855 14.6019 18.3951 17.1182C18.4597 17.4368 18.3777 17.7675 18.1719 18.019C17.9662 18.2707 17.6583 18.4166 17.3333 18.4166H8.66667C8.34165 18.4166 8.03379 18.2707 7.82805 18.019C7.62229 17.7675 7.54038 17.4368 7.60489 17.1182Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Solution coaches
                  </>
                )}
              </NavLink>
            </li>
          )}
          {user?.user?.role == "admin" && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/for-you-category">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M3.25 5.41669C3.25 3.62177 4.70508 2.16669 6.5 2.16669H19.5C21.295 2.16669 22.75 3.62177 22.75 5.41669V18.4167C22.75 20.2117 21.295 21.6667 19.5 21.6667H15.0242L13.9014 23.3509C13.7005 23.6523 13.3623 23.8334 13 23.8334C12.6377 23.8334 12.2995 23.6523 12.0986 23.3509L10.9758 21.6667H6.5C4.70508 21.6667 3.25 20.2117 3.25 18.4167V5.41669ZM10.1479 9.35608C10.1479 7.78104 11.4226 6.50002 13 6.50002C14.5774 6.50002 15.852 7.78104 15.852 9.35608C15.852 10.9311 14.5774 12.2121 13 12.2121C11.4226 12.2121 10.1479 10.9311 10.1479 9.35608ZM7.60489 17.1183C8.11453 14.6019 10.3336 12.7046 13 12.7046C15.6664 12.7046 17.8855 14.6019 18.3951 17.1183C18.4597 17.4368 18.3777 17.7676 18.1719 18.0191C17.9662 18.2708 17.6583 18.4167 17.3333 18.4167H8.66667C8.34165 18.4167 8.03379 18.2708 7.82805 18.0191C7.62229 17.7676 7.54038 17.4368 7.60489 17.1183Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    For You Category
                  </>
                )}
              </NavLink>
            </li>
          )}
          {user?.user?.role == "admin" && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/for-you-video">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        width="20"
                        height="20"
                        viewBox="3 2 21 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_8740_2202)">
                          <path
                            d="M18.25 12.5L11.125 17.25V7.74999L18.25 12.5ZM13.5 3.00177C8.26033 3.00177 4.00177 7.26033 4.00177 12.5C4.00177 17.7397 8.26033 21.9982 13.5 21.9982C18.7397 21.9982 22.9982 17.7397 22.9982 12.5C22.9982 7.26033 18.7397 3.00177 13.5 3.00177ZM13.5 4.18574C18.0979 4.18574 21.8143 7.90211 21.8143 12.5C21.8143 17.0979 18.0979 20.8142 13.5 20.8142C8.9021 20.8142 5.18574 17.0979 5.18574 12.5C5.18574 7.90211 8.9021 4.18574 13.5 4.18574Z"
                            fill={isActive ? "#064260" : "#8E8E93"}
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_8740_2202">
                            <rect
                              width="19"
                              height="19"
                              fill="white"
                              transform="translate(4 3)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    For You
                  </>
                )}
              </NavLink>
            </li>
          )}
          {user?.user?.role === "admin" && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/payer-matrix">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        width="20"
                        height="20"
                        viewBox="25 15 70 90"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M30 20 H90 V60 C90 85 60 100 60 100 C60 100 30 85 30 60 Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                        <text
                          x="60"
                          y="72"
                          textAnchor="middle"
                          fontSize="48"
                          fill="white"
                          fontFamily="Poppins, Arial"
                          fontWeight="bold"
                        >
                          $
                        </text>
                      </svg>
                    </div>
                    Payer Matrix
                  </>
                )}
              </NavLink>
            </li>
          )}
          {user?.user?.role == "admin" && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/journeys">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.1875 2.0018C14.3992 2.00326 12.6679 2.63612 11.2947 3.79035C9.92155 4.94458 8.99331 6.54716 8.67141 8.31946C7.73018 8.83105 6.9275 9.56691 6.33338 10.4628C5.73927 11.3588 5.37177 12.3875 5.26294 13.4594C4.44987 13.8198 3.73629 14.3744 3.18404 15.0753C2.63179 15.7762 2.25753 16.6023 2.09371 17.4818C1.92988 18.3614 1.98143 19.2679 2.24389 20.1229C2.50634 20.9778 2.97178 21.7554 3.59987 22.3882C4.22796 23.0209 4.99974 23.4899 5.84834 23.7543C6.69693 24.0187 7.59672 24.0706 8.46974 23.9056C9.34275 23.7405 10.1626 23.3635 10.8584 22.8071C11.5541 22.2507 12.1046 21.5318 12.4622 20.7126C13.523 20.6064 14.5421 20.2412 15.4311 19.6486C16.3201 19.0559 17.0522 18.2538 17.564 17.3117C19.4768 17.0025 21.2019 15.9735 22.3907 14.4325C23.5796 12.8914 24.1436 10.9532 23.9688 9.00942C23.794 7.06561 22.8935 5.26108 21.4492 3.96034C20.0049 2.65961 18.1243 1.95963 16.1875 2.0018ZM10.7252 18.9846C10.7252 19.0947 10.7252 19.2048 10.6488 19.3258C10.5077 19.8923 10.2199 20.411 9.81492 20.8289C9.40991 21.2468 8.90214 21.549 8.34338 21.7046C7.78462 21.8603 7.19488 21.8638 6.63432 21.7149C6.07375 21.566 5.56243 21.2699 5.1525 20.8569C4.74258 20.4439 4.44872 19.9288 4.30091 19.364C4.15309 18.7992 4.15661 18.2051 4.31111 17.6422C4.4656 17.0792 4.76555 16.5676 5.18034 16.1596C5.59513 15.7516 6.10993 15.4617 6.67221 15.3195L6.9781 15.2094C7.4911 15.1129 8.01972 15.1437 8.51824 15.2992C9.01675 15.4548 9.47014 15.7304 9.83916 16.1022C10.2082 16.4739 10.4817 16.9307 10.6361 17.433C10.7905 17.9352 10.8211 18.4678 10.7252 18.9846ZM16.1875 14.9453C16.1731 15.016 16.1549 15.0858 16.1329 15.1544C16.086 15.357 16.0239 15.5557 15.9472 15.7488C15.6957 16.3913 15.2976 16.9652 14.7852 17.4241C14.2728 17.883 13.6604 18.214 12.9975 18.3903C12.9975 18.1922 12.9976 18.0051 12.932 17.807C12.8665 17.6088 12.932 17.5098 12.932 17.3667C12.932 17.2236 12.8009 16.9485 12.7354 16.7393C12.6698 16.5302 12.6589 16.4752 12.6043 16.3431C12.5101 16.1334 12.4005 15.9311 12.2765 15.7378C12.2765 15.6387 12.1782 15.5286 12.1127 15.4296C11.9183 15.1426 11.699 14.8737 11.4572 14.6261L11.2387 14.439C11.0556 14.2694 10.8622 14.1113 10.6597 13.9657C10.5407 13.8877 10.4166 13.8178 10.2883 13.7566C10.1134 13.6446 9.93086 13.5453 9.74202 13.4594C9.60092 13.3986 9.45467 13.3507 9.30504 13.3163C9.12111 13.2411 8.93103 13.1822 8.73696 13.1402C8.58402 13.1402 8.42015 13.1402 8.25628 13.0742L7.58988 13.0082C7.76378 12.3415 8.09064 11.7252 8.54414 11.2091C8.99764 10.6929 9.56511 10.2913 10.2009 10.0365C10.3882 9.95762 10.5819 9.89502 10.7799 9.84934L10.9984 9.79431C11.2678 9.73722 11.5423 9.70772 11.8177 9.70626C12.9766 9.70626 14.0881 10.1701 14.9076 10.9957C15.7271 11.8214 16.1875 12.9412 16.1875 14.1088C16.1861 14.3899 16.1568 14.6701 16.1001 14.9453H16.1875ZM18.3724 14.7692V14.1088C18.3724 12.3574 17.6819 10.6777 16.4526 9.4392C15.2233 8.20074 13.5561 7.50499 11.8177 7.50499H11.1622C11.5223 6.68892 12.0741 5.9734 12.77 5.42021C13.466 4.86702 14.285 4.49278 15.1566 4.32978C16.0281 4.16679 16.926 4.21994 17.7726 4.48466C18.6192 4.74937 19.3891 5.2177 20.0159 5.8492C20.6427 6.4807 21.1076 7.2564 21.3703 8.10934C21.6331 8.96229 21.6858 9.86684 21.5241 10.7449C21.3623 11.623 20.9908 12.4482 20.4417 13.1493C19.8926 13.8504 19.1824 14.4064 18.3724 14.7692Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Journeys
                  </>
                )}
              </NavLink>
            </li>
          )}
          {/* Providers */}
          {user?.user?.role == "admin" && (
            <li className="nav-item ">
              <NavLink className={linkClass} to="/providers">
                <div>
                  <svg
                    className="me-2"
                    fill="none"
                    height="19"
                    viewBox="0 0 19 19"
                    width="19"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.25314 5.28113C4.25206 4.23748 4.55887 3.21695 5.13474 2.34865C5.71061 1.48035 6.52967 0.803307 7.4883 0.403164C8.44694 0.00302117 9.50207 -0.102237 10.5202 0.100704C11.5384 0.303645 12.4738 0.805668 13.2081 1.54326C13.9424 2.28085 14.4427 3.22087 14.6456 4.2444C14.8484 5.26792 14.7449 6.32896 14.3479 7.29328C13.9509 8.25759 13.2785 9.08186 12.4155 9.6618C11.5525 10.2417 10.5379 10.5513 9.49996 10.5513C8.10936 10.5513 6.77564 9.99622 5.79183 9.00803C4.80802 8.01984 4.25459 6.67937 4.25314 5.28113ZM18.9945 16.4528V18.3632C18.9945 18.5321 18.9277 18.6941 18.809 18.8135C18.6902 18.9329 18.5291 19 18.3611 19H0.633334C0.465364 19 0.304274 18.9329 0.185502 18.8135C0.0667291 18.6941 3.49567e-06 18.5321 3.49567e-06 18.3632V16.4528C-0.000715124 15.8881 0.10937 15.3288 0.323953 14.807C0.538537 14.2851 0.853402 13.811 1.25051 13.4117C1.64763 13.0124 2.11918 12.6958 2.63817 12.48C3.15716 12.2643 3.71338 12.1536 4.27498 12.1543H6.10946C6.31616 12.1533 6.52003 12.2027 6.70356 12.2983C6.8871 12.3939 7.04482 12.5329 7.16319 12.7033L8.40801 14.5643C8.52571 14.7342 8.68249 14.8729 8.86501 14.9687C9.04753 15.0645 9.25038 15.1146 9.45628 15.1146C9.66218 15.1146 9.86503 15.0645 10.0475 14.9687C10.2301 14.8729 10.3869 14.7342 10.5046 14.5643L11.8094 12.6813C11.9264 12.5121 12.0823 12.3738 12.2639 12.2782C12.4455 12.1827 12.6473 12.1326 12.8522 12.1323H14.7195C15.2834 12.1309 15.842 12.2417 16.363 12.4586C16.8841 12.6754 17.3573 12.9938 17.7552 13.3955C18.1532 13.7972 18.4681 14.2742 18.6818 14.7989C18.8954 15.3237 19.0035 15.8858 18.9999 16.4528H18.9945ZM16.8106 15.4701C16.8106 15.3973 16.7818 15.3275 16.7306 15.276C16.6794 15.2245 16.61 15.1956 16.5376 15.1956H15.5057V14.191C15.5057 14.1182 15.4769 14.0484 15.4257 13.9969C15.3745 13.9454 15.3051 13.9165 15.2327 13.9165H14.4137C14.3413 13.9165 14.2719 13.9454 14.2207 13.9969C14.1695 14.0484 14.1407 14.1182 14.1407 14.191V15.1956H13.1525C13.0801 15.1956 13.0107 15.2245 12.9595 15.276C12.9083 15.3275 12.8795 15.3973 12.8795 15.4701V16.2936C12.8795 16.3664 12.9083 16.4362 12.9595 16.4876C13.0107 16.5391 13.0801 16.568 13.1525 16.568H14.1517V17.5727C14.1517 17.6455 14.1804 17.7153 14.2316 17.7668C14.2828 17.8182 14.3522 17.8472 14.4246 17.8472H15.2436C15.316 17.8472 15.3854 17.8182 15.4366 17.7668C15.4878 17.7153 15.5166 17.6455 15.5166 17.5727V16.568H16.5157C16.5881 16.568 16.6576 16.5391 16.7088 16.4876C16.76 16.4362 16.7887 16.3664 16.7887 16.2936L16.8106 15.4701ZM9.05772 12.0555C8.87672 12.0555 8.70313 12.1278 8.57514 12.2565C8.44715 12.3852 8.37525 12.5597 8.37525 12.7417C8.37525 12.9237 8.44715 13.0982 8.57514 13.2269C8.70313 13.3556 8.87672 13.4279 9.05772 13.4279H10.1497C10.3307 13.4279 10.5043 13.3556 10.6322 13.2269C10.7602 13.0982 10.8321 12.9237 10.8321 12.7417C10.8321 12.5597 10.7602 12.3852 10.6322 12.2565C10.5043 12.1278 10.3307 12.0555 10.1497 12.0555H9.05772Z"
                      fill="#8E8E93"
                    />
                  </svg>
                </div>
                Providers
              </NavLink>
            </li>
          )}
          {/* Session History */}
          {/* {checkPermissionByRoles(user, "sessionHistory") && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/session-history">
                <div>
                  <svg
                    className="me-2"
                    fill="none"
                    height="20"
                    viewBox="0 0 18 20"
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 2H11.82C11.4 0.84 10.3 0 9 0C7.7 0 6.6 0.84 6.18 2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM9 2C9.55 2 10 2.45 10 3C10 3.55 9.55 4 9 4C8.45 4 8 3.55 8 3C8 2.45 8.45 2 9 2ZM11 16H4V14H11V16ZM14 12H4V10H14V12ZM14 8H4V6H14V8Z"
                      fill="#8E8E93"
                    />
                  </svg>
                </div>
                Session History
              </NavLink>
            </li>
          )} */}
          {/* Access Codes */}
          {user?.user?.role === "business" ? (
            <li className="nav-item">
              <NavLink className={linkClass} to={`/businesses/${businessId}`}>
                <div className="me-2">
                  {/* Access Codes SVG */}
                  <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 24 24"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                      fill="#8E8E93"
                    />
                  </svg>
                </div>
                Access Codes
              </NavLink>
            </li>
          ) : (
            user?.user?.role === "admin" && (
              <li className="nav-item">
                <NavLink className={linkClass} to="/businesses">
                  {({ isActive }) => (
                    <>
                      <div className="me-2">
                        {/* Business SVG */}
                        <svg
                          fill="none"
                          height="18"
                          viewBox="0 0 24 24"
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                            fill={isActive ? "#064260" : "#8E8E93"}
                          />
                        </svg>
                      </div>
                      Business
                    </>
                  )}
                </NavLink>
              </li>
            )
          )}

          {/* {user?.user?.role == "admin" && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/video-rotation">
                {({ isActive }) => (
                  <>
                    <div className="me-2">
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M3.25 5.41669C3.25 3.62177 4.70508 2.16669 6.5 2.16669H19.5C21.295 2.16669 22.75 3.62177 22.75 5.41669V18.4167C22.75 20.2117 21.295 21.6667 19.5 21.6667H15.0242L13.9014 23.3509C13.7005 23.6523 13.3623 23.8334 13 23.8334C12.6377 23.8334 12.2995 23.6523 12.0986 23.3509L10.9758 21.6667H6.5C4.70508 21.6667 3.25 20.2117 3.25 18.4167V5.41669ZM10.1479 9.35608C10.1479 7.78104 11.4226 6.50002 13 6.50002C14.5774 6.50002 15.852 7.78104 15.852 9.35608C15.852 10.9311 14.5774 12.2121 13 12.2121C11.4226 12.2121 10.1479 10.9311 10.1479 9.35608ZM7.60489 17.1183C8.11453 14.6019 10.3336 12.7046 13 12.7046C15.6664 12.7046 17.8855 14.6019 18.3951 17.1183C18.4597 17.4368 18.3777 17.7676 18.1719 18.0191C17.9662 18.2708 17.6583 18.4167 17.3333 18.4167H8.66667C8.34165 18.4167 8.03379 18.2708 7.82805 18.0191C7.62229 17.7676 7.54038 17.4368 7.60489 17.1183Z"
                          fill={isActive ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Daily Videos
                  </>
                )}
              </NavLink>
            </li>
          )} */}
          {/* Audit Logs */}
          {!businessIdentifier &&
            !(user?.user?.role == "provider" && onboardingLocked) && (
            <>
              <svg
                fill="none"
                height="1"
                viewBox="0 0 202 1"
                width="202"
                xmlns="http://www.w3.org/2000/svg"
                className="mb-3"
              >
                <rect fillOpacity="0.1" fill="black" height="1" width="202" />
              </svg>
              {/* Account Settings */}
              {(user?.user?.role == "provider" ||
                user?.user?.role == "careManager" ||
                user?.user?.role == "psychiatricConsultant" ||
                user?.user?.providerType == "Care Manager" ||
                user?.user?.providerType == "Psychiatric Consultant") && (
                <li className="nav-item">
                  <NavLink to="/account-settings" className={linkClass}>
                    {({ isActive }) => (
                      <>
                        <div className="me-2">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
                              fill={isActive ? "#064260" : "#8E8E93"}
                            />
                          </svg>
                        </div>
                        Account Settings
                      </>
                    )}
                  </NavLink>
                </li>
              )}
              {/* Notifications */}
              {user?.user?.role == "provider" && (
                <li className="nav-item">
                  <button
                    type="button"
                    className={`d-flex align-items-center nav-link w-100 border-0 ${
                      notificationsDrawerOpen ? `active ${classes.activeLink}` : ""
                    }`}
                    onClick={() => setNotificationsDrawerOpen(true)}
                    style={{
                      background: notificationsDrawerOpen
                        ? "rgba(6, 66, 96, 0.1)"
                        : "transparent",
                      cursor: "pointer",
                      textAlign: "left",
                    }}
                  >
                    <div className="me-2">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.4883 16.6655C21.4072 16.5679 21.3276 16.4702 21.2495 16.376C20.1753 15.0767 19.5254 14.2925 19.5254 10.6143C19.5254 8.70996 19.0698 7.14746 18.1718 5.97559C17.5097 5.10986 16.6147 4.45312 15.435 3.96777C15.4199 3.95933 15.4063 3.94825 15.395 3.93506C14.9707 2.51416 13.8095 1.5625 12.5 1.5625C11.1904 1.5625 10.0298 2.51416 9.60544 3.93359C9.59412 3.9463 9.58075 3.95703 9.56589 3.96533C6.81296 5.09863 5.47507 7.27295 5.47507 10.6128C5.47507 14.2925 4.82614 15.0767 3.75095 16.3745C3.67282 16.4688 3.59323 16.5645 3.51218 16.6641C3.3028 16.9166 3.17015 17.2238 3.12991 17.5493C3.08967 17.8748 3.14354 18.2051 3.28513 18.501C3.5864 19.1357 4.22849 19.5298 4.9614 19.5298H20.0439C20.7734 19.5298 21.4111 19.1362 21.7134 18.5044C21.8556 18.2084 21.9099 17.8779 21.87 17.552C21.8301 17.2261 21.6976 16.9184 21.4883 16.6655Z"
                          fill={notificationsDrawerOpen ? "#064260" : "#8E8E93"}
                        />
                        <path
                          d="M12.5 23.4375C13.2056 23.4369 13.8979 23.2454 14.5034 22.8832C15.109 22.5211 15.6052 22.0017 15.9395 21.3804C15.9552 21.3506 15.963 21.3172 15.962 21.2836C15.9611 21.2499 15.9515 21.217 15.9341 21.1882C15.9167 21.1594 15.8921 21.1355 15.8628 21.1189C15.8334 21.1024 15.8003 21.0937 15.7666 21.0938H9.23439C9.20066 21.0936 9.16748 21.1023 9.13807 21.1188C9.10866 21.1353 9.08403 21.1591 9.06658 21.188C9.04912 21.2168 9.03944 21.2497 9.03847 21.2835C9.0375 21.3172 9.04528 21.3506 9.06105 21.3804C9.39529 22.0017 9.89145 22.5209 10.4969 22.8831C11.1023 23.2453 11.7945 23.4368 12.5 23.4375Z"
                          fill={notificationsDrawerOpen ? "#064260" : "#8E8E93"}
                        />
                      </svg>
                    </div>
                    Notifications
                    <NotificationBadge
                      count={notificationCount}
                      setCount={setNotificationCount}
                    />
                  </button>
                </li>
              )}
              {user?.user?.role === "admin" && (
                <>
                  <div className="sidebar_text">
                    <p>Notifications</p>
                  </div>
                  <li className="nav-item">
                    <NavLink className={linkClass} to="/notification-form">
                      <div className="me-2">
                        <FaRegFileLines fill="#8E8E93" size={20} />
                      </div>
                      Notifications
                    </NavLink>
                  </li>
                </>
              )}
            </>
          )}
          {user?.user?.role == "admin" && (
            <svg
              fill="none"
              height="1"
              viewBox="0 0 202 1"
              width="202"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect fill-opacity="0.1" fill="black" height="1" width="202" />
            </svg>
          )}
          {user?.user?.role == "admin" && (
            <div className="sidebar_text">
              <p>Settings</p>
            </div>
          )}
          {/* Team Members */}
          {(user?.user?.role === "admin" ||
            user?.user?.role === "business") && (
            <li className="nav-item">
              <NavLink to="/team-member" className={linkClass}>
                <div>
                  <svg
                    className="me-2"
                    width="23"
                    height="13"
                    viewBox="0 0 23 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.863 12.0989C17.8769 12.2122 17.8667 12.3271 17.8332 12.4362C17.7996 12.5453 17.7434 12.6461 17.6682 12.732C17.5905 12.8181 17.4952 12.8866 17.3888 12.9328C17.2824 12.979 17.1673 13.0019 17.0513 12.9999H5.68715C5.57252 13.0007 5.45899 12.9773 5.35406 12.9312C5.24913 12.885 5.15517 12.8171 5.07836 12.732C5.00176 12.6468 4.94407 12.5463 4.9091 12.4372C4.87412 12.328 4.86264 12.2127 4.87543 12.0989C4.9022 11.8554 4.9456 11.614 5.0053 11.3764C5.13032 10.808 5.33818 10.261 5.62222 9.75297C5.8013 9.39982 6.0191 9.06768 6.2716 8.76267C6.60971 8.33662 7.00276 7.95722 7.44048 7.63437C8.3519 6.95158 9.42686 6.52048 10.5575 6.38431C9.79598 6.18138 9.13425 5.70839 8.69573 5.05355C8.25721 4.39871 8.07184 3.60673 8.17417 2.82529C8.27651 2.04386 8.65957 1.32632 9.25192 0.806483C9.84427 0.286646 10.6055 0 11.3936 0C12.1817 0 12.9429 0.286646 13.5352 0.806483C14.1276 1.32632 14.5107 2.04386 14.613 2.82529C14.7153 3.60673 14.53 4.39871 14.0914 5.05355C13.6529 5.70839 12.9912 6.18138 12.2297 6.38431C13.3518 6.5246 14.4179 6.9555 15.3223 7.63437C15.7601 7.95722 16.1531 8.33662 16.4912 8.76267C16.7351 9.07059 16.9472 9.40238 17.1244 9.75297C17.4023 10.2629 17.6073 10.8094 17.7332 11.3764C17.7929 11.614 17.8363 11.8554 17.863 12.0989Z"
                      fill="#8E8E93"
                    />
                    <path
                      d="M20.8583 9.75263H18.0335C17.8112 9.24968 17.5247 8.77766 17.1812 8.34835C17.525 8.20198 17.8952 8.12739 18.2689 8.12918C18.8097 8.12783 19.3399 8.27957 19.7981 8.56686C20.2563 8.85414 20.6239 9.26524 20.8583 9.75263Z"
                      fill="#8E8E93"
                    />
                    <path
                      d="M17.1244 9.75293C17.4023 10.2629 17.6073 10.8094 17.7332 11.3764H16.613C16.3977 11.3764 16.1912 11.2909 16.039 11.1386C15.8868 10.9864 15.8013 10.7799 15.8013 10.5647C15.8013 10.3494 15.8868 10.1429 16.039 9.99068C16.1912 9.83845 16.3977 9.75293 16.613 9.75293H17.1244Z"
                      fill="#8E8E93"
                    />
                    <path
                      d="M22.7334 10.4755C22.7472 10.5888 22.7371 10.7038 22.7035 10.8129C22.6699 10.922 22.6137 11.0228 22.5386 11.1087C22.4609 11.1948 22.3656 11.2633 22.2592 11.3095C22.1527 11.3557 22.0377 11.3786 21.9217 11.3765H18.5611C18.4567 10.8147 18.2793 10.2689 18.0335 9.75307H20.8583C20.6239 9.26568 20.2563 8.85458 19.7981 8.5673C19.3399 8.28001 18.8097 8.12828 18.2689 8.12962C17.8952 8.12784 17.525 8.20242 17.1812 8.34879C16.8341 7.89623 16.4334 7.48739 15.9879 7.1312C16.2643 6.96606 16.5583 6.83263 16.8646 6.73346C16.4588 6.4379 16.1569 6.02151 16.0022 5.54393C15.8475 5.06634 15.8479 4.55205 16.0033 4.07469C16.1587 3.59733 16.4612 3.18139 16.8674 2.88643C17.2737 2.59147 17.7628 2.43262 18.2648 2.43262C18.7669 2.43262 19.256 2.59147 19.6622 2.88643C20.0685 3.18139 20.3709 3.59733 20.5263 4.07469C20.6818 4.55205 20.6821 5.06634 20.5274 5.54393C20.3727 6.02151 20.0709 6.4379 19.6651 6.73346C20.4836 6.99359 21.2092 7.48556 21.7538 8.14975C22.2984 8.81394 22.6387 9.62183 22.7334 10.4755Z"
                      fill="#8E8E93"
                    />
                    <path
                      d="M5.55724 8.34835C5.21367 8.77766 4.92717 9.24968 4.70493 9.75263H1.88013C2.11454 9.26524 2.4821 8.85414 2.94031 8.56686C3.39853 8.27957 3.9287 8.12783 4.46953 8.12918C4.84324 8.12739 5.21338 8.20198 5.55724 8.34835Z"
                      fill="#8E8E93"
                    />
                    <path
                      d="M6.93728 10.5647C6.93728 10.7799 6.85176 10.9864 6.69953 11.1386C6.5473 11.2909 6.34084 11.3764 6.12555 11.3764H5.00537C5.13039 10.8079 5.33824 10.2609 5.62228 9.75293H6.12555C6.34084 9.75293 6.5473 9.83845 6.69953 9.99068C6.85176 10.1429 6.93728 10.3494 6.93728 10.5647Z"
                      fill="#8E8E93"
                    />
                    <path
                      d="M1.88015 9.75289H4.70496C4.45911 10.2687 4.28173 10.8145 4.17733 11.3763H0.816792C0.702154 11.3772 0.588632 11.3538 0.483699 11.3076C0.378767 11.2615 0.284804 11.1936 0.207998 11.1085C0.131397 11.0232 0.0737103 10.9228 0.0387337 10.8136C0.00375709 10.7045 -0.00771693 10.5892 0.00506637 10.4753C0.100618 9.62407 0.440365 8.81863 0.983346 8.1561C1.52633 7.49358 2.24936 7.00226 3.06527 6.74139C2.65948 6.44583 2.35761 6.02945 2.2029 5.55186C2.04819 5.07428 2.04857 4.55998 2.20398 4.08262C2.35939 3.60527 2.66187 3.18933 3.0681 2.89437C3.47433 2.59941 3.96348 2.44055 4.4655 2.44055C4.96752 2.44055 5.45666 2.59941 5.86289 2.89437C6.26912 3.18933 6.5716 3.60527 6.72702 4.08262C6.88243 4.55998 6.88281 5.07428 6.7281 5.55186C6.57338 6.02945 6.27152 6.44583 5.86572 6.74139C6.17198 6.84056 6.46606 6.97399 6.74239 7.13914C6.29693 7.49533 5.89627 7.90417 5.54915 8.35672C5.20839 8.20864 4.8411 8.13132 4.46956 8.12944C3.92873 8.12809 3.39856 8.27983 2.94034 8.56712C2.48212 8.8544 2.11456 9.2655 1.88015 9.75289Z"
                      fill="#8E8E93"
                    />
                    <path
                      d="M7.87894 9.3876C7.70872 9.51853 7.49355 9.57666 7.28056 9.54928C7.06756 9.52189 6.8741 9.41122 6.74253 9.24149C6.60452 9.06429 6.44655 8.90359 6.27173 8.76258C6.60984 8.33653 7.00289 7.95713 7.44061 7.63428C7.65565 7.81977 7.85145 8.02645 8.02506 8.25119C8.15598 8.42141 8.21411 8.63658 8.18673 8.84958C8.15934 9.06257 8.04867 9.25604 7.87894 9.3876Z"
                      fill="#8E8E93"
                    />
                  </svg>
                </div>
                Team Members
              </NavLink>
            </li>
          )}
          {/* Role Management */}
          {/* {checkPermissionByRoles(user, "roleManagement") && (
            <li className="nav-item">
              <NavLink to="/role_management" className={linkClass}>
                <div>
                  <svg
                    className="me-2"
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.5001 11.6806C12.7932 11.6806 13.845 10.3082 13.845 9.01535C13.845 7.72206 12.7932 6.67004 11.5001 6.67004C10.207 6.67004 9.15503 7.72206 9.15503 9.01535C9.15526 10.3082 10.207 11.6806 11.5001 11.6806Z"
                      fill="#8E8E93"
                    />
                    <path
                      d="M13.2604 11.705C12.8055 12.0513 12.2381 12.2574 11.6235 12.2574H11.3765C10.7617 12.2574 10.1941 12.0513 9.73961 11.705C8.46403 11.9108 7.44973 12.8904 7.18799 14.1464C8.0797 15.5924 9.6782 16.5591 11.4984 16.5591C13.3202 16.5591 14.9199 15.592 15.8116 14.1446C15.5494 12.8895 14.5356 11.9106 13.2604 11.705Z"
                      fill="#8E8E93"
                    />
                    <path
                      d="M1.99809 13.7106L3.5591 13.9721C3.70699 14.4514 3.90318 14.9204 4.13686 15.3682L3.23342 16.6368C2.91395 17.0228 2.94408 17.5803 3.29667 17.9343L5.0656 19.7027C5.24845 19.8847 5.4911 19.9879 5.74985 19.9879C5.97364 19.9879 6.18961 19.9093 6.34371 19.7809L7.63125 18.8623C8.0786 19.0976 8.54504 19.2922 9.02873 19.4415L9.28426 20.9799C9.33555 21.4754 9.74977 21.85 10.2484 21.85H12.7497C13.2511 21.85 13.6648 21.4754 13.7097 21.0018L13.9712 19.4412C14.4533 19.2922 14.9213 19.0976 15.3673 18.8621L16.6364 19.7669C16.8094 19.9084 17.0274 19.9781 17.2452 19.9781C17.4982 19.9781 17.7508 19.8847 17.9332 19.7018L19.7021 17.9334C20.0556 17.5803 20.0853 17.0228 19.7831 16.6548L18.8631 15.3682C19.0967 14.9222 19.2916 14.4535 19.4404 13.9702L20.9768 13.7106C21.4759 13.6652 21.8515 13.2515 21.8515 12.7501V10.2491C21.8515 9.74858 21.4759 9.33481 21.0025 9.28812L19.4406 9.02661C19.292 8.54453 19.097 8.07648 18.8633 7.63143L19.7697 6.36114C20.0855 5.97382 20.0558 5.41653 19.7037 5.06463L17.9334 3.29684C17.7515 3.11307 17.5088 3.01394 17.2501 3.01394C17.0267 3.01394 16.8089 3.08984 16.6562 3.21795L15.3673 4.1375C14.9213 3.9022 14.453 3.70808 13.9712 3.55789L13.715 2.02011C13.6646 1.52469 13.2508 1.15002 12.7497 1.15002H10.2484C9.74977 1.15002 9.33555 1.52469 9.28886 1.99826L9.02873 3.55789C8.54481 3.70785 8.0786 3.90198 7.63125 4.1375L6.36165 3.23014C6.18938 3.08984 5.97203 3.02038 5.75422 3.02038C5.50191 3.02038 5.2496 3.11353 5.06652 3.29707L3.29667 5.06486C2.94132 5.41791 2.91395 5.97635 3.21663 6.34458L4.13663 7.63166C3.90295 8.07694 3.70814 8.54499 3.55887 9.02684L2.0204 9.28421C1.5236 9.33504 1.14893 9.74881 1.14893 10.2491V12.7503C1.14893 13.2515 1.5236 13.6652 1.99809 13.7106ZM11.4985 5.51911C14.7976 5.51911 17.4808 8.20045 17.4808 11.4991C17.4808 14.7987 14.7976 17.4791 11.4985 17.4791C8.20234 17.4791 5.51801 14.7987 5.51801 11.4991C5.51801 8.20045 8.20234 5.51911 11.4985 5.51911Z"
                      fill="#8E8E93"
                    />
                  </svg>
                </div>
                Role Management
              </NavLink>
            </li>
          )} */}
          {/* Change Password */}
          {(user?.user?.role === "admin" ||
            user?.user?.role === "business") && (
            <li className="nav-item">
              <NavLink className={linkClass} to="/change-password">
                <div>
                  <svg
                    className="me-2"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1189_1785)">
                      <path
                        d="M18.9111 10.6742C18.9892 10.2494 19.0323 9.81235 19.0323 9.36559C19.0323 5.30437 15.6533 2 11.5 2C7.34653 2 3.96736 5.30437 3.96736 9.36559C3.96736 9.81235 4.01063 10.249 4.08893 10.6742C3.43491 11.0708 3 11.7643 3 12.5563V19.7669C3 21.0003 4.05299 22 5.35149 22H17.6483C18.9465 22 19.9993 21.0003 19.9993 19.7669L20 12.5563C20 11.7644 19.5655 11.0708 18.9111 10.6742ZM12.5376 16.9702V18.5372C12.5376 18.7986 12.4282 19.0493 12.2336 19.2341C12.0389 19.419 11.7749 19.5228 11.4996 19.5228C11.2244 19.5228 10.9603 19.419 10.7657 19.2341C10.571 19.0493 10.4617 18.7986 10.4617 18.5372V16.9695C9.79593 16.6211 9.34433 15.9489 9.34433 15.1759C9.34433 14.0456 10.3093 13.1291 11.5 13.1291C12.6907 13.1291 13.6558 14.0456 13.6558 15.1759C13.6558 15.9493 13.2039 16.622 12.5376 16.9702ZM16.1663 10.323H6.83352C6.76824 10.0076 6.73539 9.68699 6.73542 9.36559C6.73542 6.75346 8.87275 4.62849 11.5 4.62849C14.1271 4.62849 16.2642 6.75329 16.2642 9.36559C16.2642 9.69343 16.2305 10.014 16.1663 10.323Z"
                        fill="#8E8E93"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1189_1785">
                        <rect fill="white" height="24" width="24" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                Change Password
              </NavLink>
            </li>
          )}
        </ul>
      </div>

      {/* Notifications Drawer */}
      {user?.user?.role === "provider" && (
        <NotificationsDrawer
          open={notificationsDrawerOpen}
          onClose={() => setNotificationsDrawerOpen(false)}
          providerId={user?.user?.providerId}
          setNotificationCount={setNotificationCount}
        />
      )}
    </div>
  );
};

export default Sidebar;
